import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { AuthSessionRepository } from '../repositories/AuthSessionRepository';
import { AuthSession } from '../domain/entities/AuthSession';
import { SetGuestAuthSessionUseCase } from './SetGuestAuthSessionUseCase';

export class InitializeTokenUseCase {
    private authSessionRepository: AuthSessionRepository;
    private authSession: AuthSession;

    constructor() {
        this.authSessionRepository = diContainer.get(serviceNames.authSessionRepository);
        this.authSession = diContainer.get(serviceNames.authSession);
    }

    public execute = async () => {
        const { storedAuthSession } = this.authSessionRepository;
        if (storedAuthSession.isAuthSessionAvailable) {
            this.authSession.updateAuthSession(storedAuthSession);
        } else {
            const setGuestAuthSessionUseCase = new SetGuestAuthSessionUseCase();
            await setGuestAuthSessionUseCase.execute();
        }
    };
}
